<template>
  <div
    v-if="totalPages > 1 || totalRows > 0"
    class="mobile-pagination"
  >
    <div class="mobile-pagination__summary">
      {{ first.toLocaleString() }}-{{ last.toLocaleString() }} of
      {{ totalRows.toLocaleString() }}
    </div>
    <div
      v-if="totalPages > 1"
      class="mobile-pagination__controls"
    >
      <b-button
        variant="bg-white"
        class="mobile-pagination__button"
        :disabled="value <= 1"
        aria-label="Previous page"
        @click="goTo(value - 1)"
      >
        <GjIcon
          name="ArrowLeft"
          size="18"
        />
      </b-button>
      <span class="mobile-pagination__page">
        Page {{ value }} / {{ totalPages }}
      </span>
      <b-button
        variant="bg-white"
        class="mobile-pagination__button"
        :disabled="value >= totalPages"
        aria-label="Next page"
        @click="goTo(value + 1)"
      >
        <GjIcon
          name="ArrowRight"
          size="18"
        />
      </b-button>
    </div>
  </div>
</template>

<script>
/**
 * Compact pager for small screens: b-pagination's numbered links overflow
 * below ~400px, so we show prev/next with a page counter instead.
 */
export default {
  name: 'MobilePagination',
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: {
      type: Number,
      required: true,
    },
    totalRows: {
      type: Number,
      default: 0,
    },
    perPage: {
      type: Number,
      default: 10,
    },
  },
  computed: {
    totalPages() {
      if (!this.perPage) return 0
      return Math.ceil(this.totalRows / this.perPage)
    },
    first() {
      if (!this.totalRows) return 0
      return (this.value - 1) * this.perPage + 1
    },
    last() {
      return Math.min(this.value * this.perPage, this.totalRows)
    },
  },
  methods: {
    goTo(page) {
      if (page < 1 || page > this.totalPages || page === this.value) return
      this.$emit('input', page)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables/variables';

.mobile-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 4px 0 20px;

  &__summary {
    font-size: 12px;
    font-weight: 500;
    color: $blue-800;
  }

  &__controls {
    display: flex;
    align-items: center;
  }

  &__page {
    padding: 0 10px;
    font-size: 12px;
    font-weight: 600;
    color: $blue-700;
    white-space: nowrap;
  }

  &__button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    min-width: 40px;
    height: 40px;
    padding: 0;
    margin-right: 0 !important;
  }
}
</style>
